// extracted by mini-css-extract-plugin
export default {"advertDetailInfoPrice":"c-h_fz","advertDetailInfoPrice__value":"c-h_fA","advertDetailInfoPrice__label":"c-h_fB"};